<template>
  <section>
    <div
      @click="goBack"
      class="cursor-pointer flex items-center my-5 justify-start border rounded-lg w-20 px-3 py-2"
    >
      <back-arrow />
      <p class="text-root-4 ml-2 font-normal text-xs">Back</p>
    </div>
    <make-payment-local
      v-if="!transferSourceIsGlobalFiat && !transferSourceIsAsset"
    />
    <make-payment-asset
      v-if="transferSourceIsAsset"
      @updateAssetTransferDetails="$emit('updateAssetTransferDetails')"
      @goToEnterAmount="$emit('goToEnterAmount')"
    />
    <make-payment-usd-to-local
      v-if="transferSourceIsGlobalFiat"
      :useType="useType"
      class="lg:w-11/12 mx-auto"
      @goToEnterAmount="$emit('goToEnterAmount')"
    />
  </section>
</template>
<script>
import exchangeRate from '@/mixins/localDeposit.js'
export default {
  mixins: [exchangeRate],
  props: {
    useType: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack () {
      this.$emit('prev')
    }
  },
  components: {
    MakePaymentAsset: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment//MakePaymentAsset.vue'
      ),
    BackArrow: () => import('@/assets/icons/BackArrow.vue'),
    MakePaymentUsdToLocal: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/MakePaymentUsdToLocal.vue'
      ),
    MakePaymentLocal: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/MakePaymentLocal.vue'
      )
  }
}
</script>
